// src/routes/PrivateRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";

const PrivateRoute = () => {
  const [authChecked, setAuthChecked] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (loggedInUser) => {
      setUser(loggedInUser);
      setAuthChecked(true); // Set once authentication state is determined
    });

    return () => unsubscribe();
  }, []);

  if (!authChecked){
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Checking authentication...</p>
      </div>
    );
  };

  return user ? <Outlet /> : <Navigate to="/agent-login" />;
};

export default PrivateRoute;
